import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  const aboutLinks = [
    { path: '/about', label: 'About Us' },
    { path: '/about/mission-vision', label: 'Mission & Vision' },
    { path: '/about/history', label: 'Our History' },
    { path: '/about/why-choose-us', label: 'Why Choose Us' },
  ];

  const serviceLinks = [
    { path: '/services', label: 'All Services' },
    { path: '/services/coaching-programs', label: 'Coaching Programs' },
    { path: '/services/facilities', label: 'Facilities' },
    { path: '/services/membership', label: 'Membership Plans' },
  ];

  const blogLinks = [
    { path: '/blog', label: 'All Articles' },
    { path: '/events', label: 'Events & News' },
  ];

  return (
    <>
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="top-bar-contact">
              <a href="tel:+91 97281 54227">
                <FaPhone /> +91 97281 54227
              </a>
              <a href="mailto:info@imperialbadminton.com">
                <FaEnvelope /> info@imperialbadminton.com
              </a>
            </div>
            <div className="top-bar-social">
              <span>Follow us for updates!</span>
            </div>
          </div>
        </div>
      </div>

      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="navbar-content">
            <Link to="/" className="navbar-brand">
              <div className='set'>
                <img src="/img/logo.png" alt="logo" />
              </div>
            </Link>

            <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>

            <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
              <li className="nav-item">
                <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                  Home
                </Link>
              </li>

              <li className={`nav-item dropdown ${activeDropdown === 'about' ? 'active' : ''}`}>
                <button
                  className="dropdown-toggle"
                  onClick={() => handleDropdown('about')}
                >
                  About <FaChevronDown />
                </button>
                <ul className="dropdown-menu">
                  {aboutLinks.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path} className={location.pathname === link.path ? 'active' : ''}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              <li className={`nav-item dropdown ${activeDropdown === 'services' ? 'active' : ''}`}>
                <button
                  className="dropdown-toggle"
                  onClick={() => handleDropdown('services')}
                >
                  Services <FaChevronDown />
                </button>
                <ul className="dropdown-menu">
                  {serviceLinks.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path} className={location.pathname === link.path ? 'active' : ''}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              {/* <li className="nav-item">
                <Link to="/our-staff" className={location.pathname === '/our-staff' ? 'active' : ''}>
                  Our Staff
                </Link>
              </li> */}

              <li className="nav-item">
                <Link to="/testimonials" className={location.pathname === '/testimonials' ? 'active' : ''}>
                  Testimonials
                </Link>
              </li>

              <li className={`nav-item dropdown ${activeDropdown === 'blog' ? 'active' : ''}`}>
                <button
                  className="dropdown-toggle"
                  onClick={() => handleDropdown('blog')}
                >
                  Blog <FaChevronDown />
                </button>
                <ul className="dropdown-menu">
                  {blogLinks.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path} className={location.pathname === link.path ? 'active' : ''}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              <li className="nav-item">
                <Link to="/contact" className={`btn btn-primary nav-cta ${location.pathname === '/contact' ? 'active' : ''}`}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
